"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollableFadeOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const LeaderboardContext_1 = require("../Context/LeaderboardContext");
const ScrollableFadeOverlay = ({ stackRef, dataDependency }) => {
    const { appTheme } = (0, LeaderboardContext_1.useLeaderboardContext)();
    const [isScrolledToBottom, setIsScrolledToBottom] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            if (stackRef.current) {
                const { scrollTop, scrollHeight, clientHeight } = stackRef.current;
                const isAtBottom = scrollHeight - scrollTop - clientHeight < 5;
                setIsScrolledToBottom(isAtBottom);
            }
        };
        const stackElement = stackRef.current;
        if (stackElement) {
            handleScroll();
            stackElement.addEventListener('scroll', handleScroll);
            return () => {
                stackElement.removeEventListener('scroll', handleScroll);
            };
        }
    }, [stackRef, dataDependency]);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            position: 'absolute',
            bottom: -2,
            left: 0,
            right: 0,
            height: '50px',
            background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.5), ${appTheme?.palette?.background?.paper ?? '#fff'})`,
            pointerEvents: 'none',
            opacity: isScrolledToBottom ? 0 : 1,
            transition: 'opacity 0.3s ease-in-out',
        } }));
};
exports.ScrollableFadeOverlay = ScrollableFadeOverlay;
